import { Repository } from "src/firebase/firestore/repository";
import { PromoCode } from "./types/promo-code.entity";

export class PromoCodeRepository extends Repository<PromoCode> {
  constructor() {
    super("promo_codes");
  }
}

export const promoCodeRepository = new PromoCodeRepository();
